import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

/**
 * Опции для выбора типа ходатайства
 */
export const agreementsTypeSelectOptions: ISelectOption<number>[] = [
  {
    id: 1,
    label: 'Контролируемое лицо',
    value: 1,
  },
  {
    id: 2,
    label: 'Учредитель',
    value: 2,
  },
];
